import axios from "axios";

export const loadAllCenterProductsAPI = (payload) => {
  return axios
    .get(
      `${payload.dataURL}?status=${
        payload.appliedFilters.status
      }&removal=${!!payload.appliedFilters.removal}&supply=${!!payload
        .appliedFilters.supply}&limit=${payload.pageSize}&page=${
        payload.currentPage
      }&orderBy=${payload.sort ? payload.sort.dir : "desc"}&orderColumn=${
        payload.sort ? payload.sort.column : "id"
      }&search=${payload.search ?? ""}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const loadSingleCenterProductAPI = (payload) => {
  return axios
    .get(
      `/companies/${payload.companyId}/centres/${payload.centerId}/products/${payload.centerProductId}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then((res) => res.data);
};
